import type { DeviceDeploymentInfoV4 } from '@emma/api_client/types';
import { Flex, Link, Tag } from '@lego/klik-ui';
import type { MouseEvent } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { paths } from '@/utility/global_paths';
import { StatusIcon } from './icons/StatusIcon';

type Props = {
  deployment: DeviceDeploymentInfoV4;
  workspaceId?: number;
  activeDeploymentId?: number | null;
};

export const DeviceDeploymentBadge = ({ deployment, workspaceId, activeDeploymentId }: Props) => {
  const isSuccess = deployment.latestState === 'SUCCEEDED';
  const isOutdated =
    isSuccess && activeDeploymentId != null && deployment.deploymentId !== activeDeploymentId;

  const badge = (
    <Tag variant="plain">
      <Tag.Label>
        <Flex alignItems={'baseline'} gap={2}>
          <StatusIcon
            isOutdated={isOutdated}
            isSuccess={isSuccess}
            reason={
              isOutdated
                ? `The deployment is running but not up to date. A newer deployment (${activeDeploymentId}) is available`
                : deployment.latestState !== 'SUCCEEDED' && deployment.failureReason
                  ? `The deployment failed with reason: ${deployment.failureReason}`
                  : deployment.latestState === 'SUCCEEDED'
                    ? 'The deployment was successfully deployed'
                    : 'Deployment status unknown'
            }
            timestamp={deployment?.deploymentStatusUpdatedAt ?? undefined}
          />
          {deployment.deploymentId}
        </Flex>
      </Tag.Label>
    </Tag>
  );

  return workspaceId != null ? (
    <Link
      as={ReactRouterLink}
      data-interactive
      onClick={(event: MouseEvent<HTMLAnchorElement>) => event.stopPropagation()}
      p={0}
      to={paths.deploymentById(workspaceId, deployment.fleetId, deployment.deploymentId)}
    >
      {badge}
    </Link>
  ) : (
    badge
  );
};
